import React from "react";
import HeroPasserelleISS from "../../Components/HeroPasserelleISS/HeroPasserelleISS";
import PasserelleISSIntro from "../../Components/PasserelleISSIntro/PasserelleISSIntro";

export default function PasserelleISS() {
  return (
    <main>
      <HeroPasserelleISS />
      <PasserelleISSIntro />
    </main>
  );
}